import { useState } from 'react';
import './App.css';
import SearchAppBar from './component/SearchAppBar';
import MenuDrawer from './component/MenuDrawer';
import { Box, CssBaseline } from '@mui/material';
import NavigationPage from './component/pages/NavigationPage';
import DatetimeUtilityPage from './component/pages/DatetimeUtilityPage';
import FinancialPage from './component/pages/FinancialPage';
import UtilitiesPage from './component/pages/UtilitiesPage';
import DeveloperToolsPage from './component/pages/DeveloperToolsPage';

function App() {
  const [drawerOpen, setDrawerOpen] = useState(true); // Start with drawer open
  const [currentView, setCurrentView] = useState('');
  const [activeTab, setActiveTab] = useState<string | undefined>(undefined);
  const [searchText, setSearchText] = useState('');

  const handleSetCurrentView = (viewPath: string) => {
    const [view, tab] = viewPath.split('#');
    setCurrentView(view);
    setActiveTab(tab);
  };  const renderComponent = () => {
    // Pass activeTab to pages that support it
    const initialTab = (currentView === 'datetime-utility' || currentView === 'financial' || currentView === 'utilities' || currentView === 'dev-tools') ? activeTab : undefined;

    switch(currentView) {
      case 'datetime-utility': return <DatetimeUtilityPage initialTabKey={initialTab} />;
      case 'financial': return <FinancialPage initialTabKey={initialTab} />;
      case 'utilities': return <UtilitiesPage initialTabKey={initialTab} />;
      case 'dev-tools': return <DeveloperToolsPage initialTabKey={initialTab} />;
      
      default: return <NavigationPage setCurrentView={handleSetCurrentView}/>; // Use the new handler
    }
  };  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };
  const drawerWidth = 280; // Increased width for better navigation
  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <SearchAppBar
        toggleDrawer={toggleDrawer}
        setCurrentView={handleSetCurrentView} // Use the new handler
        searchText={searchText}        setSearchText={setSearchText}
      />
      <MenuDrawer
        drawerWidth={drawerWidth}
        drawerOpen={drawerOpen}
        setCurrentView={handleSetCurrentView}
      />
      <Box
        component='main'
        sx={{
          flexGrow: 1,
          pt: (theme) => theme.mixins.toolbar.minHeight ? `calc(${theme.mixins.toolbar.minHeight}px + ${theme.spacing(2)})` : theme.spacing(10),
          paddingLeft: (theme) => theme.spacing(2),
          paddingRight: (theme) => theme.spacing(2),
          paddingBottom: (theme) => theme.spacing(2),
          width: `calc(100% - ${drawerOpen ? drawerWidth : 0}px)`,
          marginLeft: drawerOpen ? `${drawerWidth}px` : 0,
          transition: (theme) =>
            theme.transitions.create(['width', 'margin'], {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.leavingScreen,
            }),
        }}
      >
        {renderComponent()}
        {/* <Routes>
          <Route path='/' element={<NavigationPage />} />
          <Route path='/datetimeCalculation' element={<DatetimeCalcPage />} />
          // Add more routes as needed
        </Routes> */}
      </Box>
    </Box>
  );
}

export default App;
